import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "formatTime" })
export class FormatTimePipe implements PipeTransform {
  transform(ms: number): string {
    const totalMinutes = Math.floor(ms / 60000);
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalMinutes / 60);
    const seconds = totalSeconds % 60;
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
  }
}
